import React, {useState, useEffect, useContext, useRef, useCallback} from 'react';
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import t from "../../Utils/Translation";
import {styled} from "@mui/material/styles";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Ratio from 'react-bootstrap/Ratio';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import {Modal} from "react-bootstrap";
import CommentSharpIcon from '@mui/icons-material/CommentSharp';
import VisibilitySharpIcon from '@mui/icons-material/VisibilitySharp';
import GradeSharpIcon from '@mui/icons-material/GradeSharp';
import StackedBarChartSharpIcon from '@mui/icons-material/StackedBarChartSharp';
import createDOMPurify from 'dompurify';
import InputEmoji from 'react-input-emoji';
import {Viewer, Worker} from "@react-pdf-viewer/core";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";
//import './previewStory.css';

const LykioPostStoryButton = styled(Button)(() => ({
    backgroundColor: "#003d7d",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
      backgroundColor: "white",
      color: "#003d7d",
      borderStyle: 'solid !important',
      borderWidth: '0.2em',
      borderRadius: '7px',
      borderColor: "#003d7d"
    },
  }));

const PreviewStory = ({title, file, editorJSDataHTML, selectedColor, isPdf, pdf, image, duration}) => {
    const context = useContext(LykioContext);
    const [modal, setModal] = useState(null);
    const DOMPurify = createDOMPurify();
    const user = context.userDetails;
    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
      });
    
    
      const renderToolbar = (Toolbar) => (
          <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
      )
      const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});
    
      const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance

    const handleOpen = (id) => {
        setModal(id);
    };

    const handleClose = () => {
        setModal(null);
    };

    const previewStoryBoxHandler = (previewId) => {
        if (title && file) {
          handleOpen(previewId);
        }
      }
    
      const userStoryText = (userText) => {
        const text = editorJSDataHTML && editorJSDataHTML.map((htmlTags) => htmlTags).join(' ');
        return { __html: DOMPurify.sanitize(text) };
      }

    

    return (
        <div className="mb-3" style={{display:'flex', justifyContent:'end'}}>
            <LykioPostStoryButton style={{marginRight:'1rem'}}
                onClick={()=> previewStoryBoxHandler(1)}
                variant="contained">
                {t("Post preview")}
            </LykioPostStoryButton>
                        
            <LykioPostStoryButton 
                onClick={()=> previewStoryBoxHandler(2)}
                variant="contained">
                {t("Content preview")}
            </LykioPostStoryButton>
            {modal === 1 && (

            <Modal show={true} onHide={handleClose} size='md' centered >
              <Modal.Header closeButton>
                  <Modal.Title>{t("Post preview")}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="card text-white text" style={{ background: selectedColor }}>
                  <div className="card-header text-center py-2" >{title}</div>
                  {!isPdf ? <Image className="card-img" fluid src={image} alt="preview image"/> :
                  <Image className="card-img" fluid 
                  src={'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/pdfDefaultCover.jpeg'} alt="preview image"/>}
                  
                  <div className="card-footer d-flex justify-content-between py-0" style={{background: selectedColor}}>
                    {/*<div>{props.story.completed ? <DoneIcon/> : <></>}</div>*/}
                    <div style={{marginLeft:'auto'}}>
                      <div>{{duration} && `${duration} min`}</div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
        )}

        {modal === 2 && (
          <Modal show={true} onHide={handleClose} size={isPdf ? 'xl' : 'lg'} centered>
          <Modal.Header closeButton>
            <Container>
              <Row>
                <Col xs={12}>
                  <Modal.Title>{t("Content preview")}</Modal.Title>
                </Col>
              </Row>
            </Container>
            </Modal.Header>
          <Modal.Header>
          <Container>
          <Row>
            <Col xs={9}>
              <div className='lykiocss-unitoverview-unit-title'>{title}</div>
            </Col>
            <Col xs={3}>
              <div className="d-flex justify-content-center lykiocss-margin-top-1em">
              <Tooltip title={`0 ${t('comments')}`}>
              <span>
              0
              <CommentSharpIcon/><span>&nbsp;</span>
              </span>
              </Tooltip>

              <Tooltip title={`0 ${t('times rated')}`}>
              <span>
                0
                <GradeSharpIcon/><span>&nbsp;</span>
              </span>
              </Tooltip>


              <Tooltip title={`0 ${t('times viewed')}`}>
              <span>
                0
                <VisibilitySharpIcon/><span>&nbsp;</span>
              </span>
              </Tooltip>


              <Tooltip title={`0 ${t('Impact Index')}`}>
              <span>
                0
                <StackedBarChartSharpIcon/><span>&nbsp;</span>
              </span>
              </Tooltip>
            </div>
            </Col>
          </Row>
          </Container>
          </Modal.Header>
          
          <Modal.Body style={{padding:'0rem'}}>
          <Container>
            <div className="lykiocss-unitModal-container">
              <div className="lykiocss-unitModal-media">
                {!isPdf && <Ratio aspectRatio="1x1">
                    <Image className="card-img" fluid src={image} alt="preview image"/>
                </Ratio>}
                
                {isPdf &&
                <div style={{height:'80vh'}}>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                    <Viewer fitToWidth={true} fileUrl={pdf} plugins={[defaultLayoutPluginInstance]} />
                </Worker>
                </div>}
                <div className="lykiocss-unitModal-story-uploader-name">
                  {!isPdf && `${user.firstname}'s Post`}
                </div>
                <div
                  className="lykiocss-unitModal-story-text-image"
                >
                  
                  <div dangerouslySetInnerHTML={userStoryText(editorJSDataHTML)} />
                </div>
              </div>
              <div className="lykiocss-unitModal-comments-rating">
                <div className="lykiocss-comments-wrap">
                  <div className="lykiocss-comments-heading">
                    <Tooltip title={`${user.firstname}  ${user.lastname}`}> 
                      <div className="lykiocss-comments-uploader-info">
                        <Image src={user.profilepicture} className="lykiocss-active-profile-image rounded-circle" 
                        style={{width:'3rem', height: '3rem'}} />
                        <span className="lykiocss-active-profile-name lykiocss-text-shadow"
                        style={{color:'#0d6efd'}}>&nbsp;{user.firstname} {user.lastname}</span>
                      </div>
                    </Tooltip>
                  </div>
                  <div className="lykiocss-comments-area">
                    <div className="lykiocss-comments-middle">
                        <ul className="lykiocss-comments-container">
                        <span>{t('No comments yet. Be the first to comment!')}</span>
                        </ul>
                    </div>
                  </div>
                  <div>
                      <div className="lykiocss-comments-rating">
                        <div>
                          <span>&#9734;</span><span>&#9734;</span><span>&#9734;</span><span>&#9734;</span><span>&#9734;</span>
                        </div>
                        <div className="lykiocss-comments-bookmarkbutton">
                        <Tooltip title={t("Add to my Favourites playlist")}><i className="bi bi-bookmark" />
                        </Tooltip>
                                  </div>
                      </div>
                      <div className="lykiocss-comments-commentbox" style={{pointerEvents:'none'}}>
                        <div className="lykiocss-comments-input-emoji">
                          <InputEmoji
                            placeholder={t('Add a comment...')}
                          />
                            <div className="lykiocss-comments-postbuttondiv">
                                <button type="button" className="lykiocss-comments-postbutton">
                                    {t("Post")}
                                </button>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Modal.Body>

        </Modal>
        )}
        </div>

    )
}

export default PreviewStory;